module.exports = __webpack_public_path__ + "static/media/Naiful.7f65a866.jpg";